import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/core/services/storage.service';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CommonService } from 'src/app/core/services/common.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-progress-tracker',
  templateUrl: './progress-tracker.component.html',
  styleUrls: ['./progress-tracker.component.css'],
})
export class ProgressTrackerComponent implements OnInit {
  questionnaireList: any;
  isArabic!: boolean;
  isMakerCheckerEnabled: any;
  isChecker: any;
  modalRef!: BsModalRef;
  modalRefDeactivate!: BsModalRef;
  userData: any;
  // showDetails = false;
  constructor(private storageService: StorageService, private commonService: CommonService, private route: Router,
    private assessmentService: AssessmentService, private modalService: BsModalService) { }

  ngOnInit(): void {
    this.userData = this.storageService.getSessionStorageData('userDetails');
    this.isChecker = this.storageService.getSessionStorageData('isChecker');
    this.isMakerCheckerEnabled = this.storageService.getSessionStorageData('isMakerCheckerEnabled');
    //console.log('sessionData in assessment: ', this.userData);
    this.isArabic = this.storageService.getSessionStorageData('isArabic');


    if (this.isMakerCheckerEnabled) {
      const rqstBody = { assessmentUnit: this.userData?.assessmentUnitValue, contactguid: this.userData?.contactguid };
      this.assessmentService.fetchProgressTrackerQuestionnaireList(rqstBody).subscribe((res) => {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        //console.log('get questionnaire list in assessment: ', decryptedData);
        let resp = JSON.parse(JSON.stringify(decryptedData));
        this.questionnaireList = resp.questionnaires;
        //console.log('list of questionnaires: ', this.questionnaireList);
      }, (error: any) => {
        //console.log('server error check: ', error);
        if (error?.body?.error == 'The Assossicated Assessment Entity has deactivated') {
          this.showDeactivationPopup();
        }
      });
    } else {
      const rqstBody = { assessmentUnit: this.userData?.assessmentUnitValue, isProgressTracker: true, contactguid: this.userData?.contactguid };
      this.assessmentService.fetchQuestionnaireList(rqstBody).subscribe((res) => {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        //console.log('get questionnaire list in assessment: ', decryptedData);
        let resp = JSON.parse(JSON.stringify(decryptedData));
        this.questionnaireList = resp.questionnaires;
        //console.log('list of questionnaires: ', this.questionnaireList);
      }, (error: any) => {
        //console.log('server error check: ', error);
        if (error?.body?.error == 'The Assossicated Assessment Entity has deactivated') {
          this.showDeactivationPopup();
        }
      });
    }
  }

  showDeactivationPopup() {
    let pathUrl = 'login';
    let message = '';
    if (this.isArabic) {
      message = '.تم إلغاء تنشيط كيان الاتصال / التقييم';
    } else {
      message = 'Contact/Assessment Entity has been deactivated.';
    }
    const initialState = {
      message: message,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRefDeactivate = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }

  showProgressDetails(item: any) {
    //this.showDetails = true;
    let rqstBody = {
      questionnaire: item.questionnaireMdeValue,
      assessmentUnit: this.userData?.assessmentUnitValue,
      isChecker: this.isChecker,
      isMakerCheckerEnabled: this.isMakerCheckerEnabled
    };
    this.assessmentService.fetchTotalNoOfQues(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      // console.log('finally number of questions: ', resp);
      let progressDetails = resp;
      progressDetails.questionnaireProgress = item.questionnaireProgress;
      progressDetails.assessmentName = item.questionnaireName;
      if (resp.totalQuestions <= 0) {
        let message;
        if (this.isArabic) {
          message = 'لا يوجد سؤال متاح لهذا التقييم.';
        } else {
          message = 'No question is available for this assessment.';
        }
        let pathUrl = '';
        const initialState = {
          message: message,
          redirectTo: pathUrl
        };
        this.modalRef = this.modalService.show(NotificationComponent, { initialState });
      } else {
        this.assessmentService.setProgressDetailsData(progressDetails);
        this.route.navigate(['executor-dashboard/progress-tracker-details'], { state: { parent: "executor-dashboard" } });
      }
    });
  }
}
